export const COLORS = {
    red: "#DF1116",
    dark_red: "#AA0D11",
    green:"#2C815E",
    bg_green:"#F0FAF6",
    bg_red:"#FFEFEF",
    blue:"#2b7df8"
} as const;

export type ColorKey = keyof typeof COLORS;
export type ColorValue = typeof COLORS[ColorKey];